export const state = {
  interchanges: [],
  systemInterchange: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/interchanges/state.js